// extracted by mini-css-extract-plugin
export default {"formGroup":"CheckingContent_formGroup__fO6ja","textAria":"CheckingContent_textAria__79gNF","blockSelects":"CheckingContent_blockSelects__vm3kh"};